import {IssueViewerSecondaryViewServerQuery} from '@github-ui/server-persisted-queries'
import type {IssueViewerSecondaryViewServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewServerQuery'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type IssueViewerSecondaryViewFeatures = {
  readonly hideClosedSubIssues?: boolean
}

export type IssueViewerSecondaryViewResponse = {
  readonly repository: IssueViewerSecondaryViewServerQueryQuery['repository']
  readonly features?: IssueViewerSecondaryViewFeatures
}

export function issueViewerSecondaryViewQueryKey(owner: string, repo: string, number: number) {
  // Deliberately excludes `markAsRead` so toggling it doesn't bust/duplicate the cache entry,
  // mirroring the Relay path's `excludeFromCacheKey: ['markAsRead']`.
  return ['issue-viewer', 'secondary-view', {owner, repo, number}] as const
}

export async function fetchIssueViewerSecondaryView(
  owner: string,
  repo: string,
  number: number,
  markAsRead: boolean,
  signal?: AbortSignal,
): Promise<IssueViewerSecondaryViewResponse> {
  const response = await verifiedFetchJSON(
    `/${owner}/${repo}/issues/${number}/secondary_view?markAsRead=${markAsRead}&queryId=${IssueViewerSecondaryViewServerQuery}`,
    {signal},
  )
  if (!response.ok) {
    throw new Error(`Issue viewer secondary view fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {
    data?: IssueViewerSecondaryViewServerQueryQuery
    errors?: unknown[]
    features?: IssueViewerSecondaryViewFeatures
  }
  if (json.errors?.length || !json.data) {
    throw new Error('Issue viewer secondary view query returned errors')
  }

  return {
    repository: json.data.repository,
    features: json.features,
  }
}
